import { useQuery } from "@tanstack/react-query";
import { route } from "../../../../../../shim/jsbridge";
import { Analysis } from "../../../../@types";
import api from "../../../../api";
import { sampleReportKeys } from "../../../../queryKeys";

const useGetNetworkCounts = <T>(
  hash: string | undefined,
  analysis: Analysis,
  uploadId?: string
) => {
  const endpoint = uploadId
    ? route(`api_${analysis}_url_network_counts`, [uploadId])
    : route(`api_${analysis}_network_counts`, [hash]);

  return useQuery({
    queryKey: sampleReportKeys.networkCounts(hash, analysis, endpoint),
    queryFn: () => api.getDynamicAnalysisData<T>(endpoint),
    select: ({ data: counts }) => counts
  });
};

export default useGetNetworkCounts;
